import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-confirm-termination-moha',
  templateUrl: './confirm-termination-moha.component.html',
  styleUrls: ['./confirm-termination-moha.component.scss']
})
export class ListConfirmTerminationComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ListConfirmTerminationComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

  confirm(isNew) {
    this.dialogRef.close(isNew);
  }

}
